import React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useCognito, useCognitoDispatch } from 'components/Cognito/CognitoContextProvider'
import ErrorMessage from 'components/Shared/ErrorMessage'
import LoadingSpinner from 'components/Shared/LoadingSpinner'
import { SecondaryButton } from 'components/Shared/Button'
import { useDispatch, useSelector } from 'react-redux'
import { usePostLoginRedirect } from 'components/Cognito/hooks'
import { FormPage } from 'components/Cognito/Shared/FormPage'
import LoginSuccess from 'components/Cognito/LoginSuccess'
import PartnerSelect from 'components/Cognito/PartnerSelect'
import { hasSinglePartner } from 'utils/cognitoGroups'

export default function PostAuthenticatorSetup() {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const {
    loading,
    error,
    user: { isLogged },
  } = useCognito()
  const { logout } = useCognitoDispatch()
  const { selectedPartner, setSelectedPartner, loginState, showSplash, setShowSplash } =
    usePostLoginRedirect()

  const handleError = () => {
    logout()
    history.replace('/login')
  }

  if (loading) {
    return (
      <div className="setup-authenticator_relogin">
        <LoadingSpinner title={t('Login.form.btnLoading')} />
      </div>
    )
  }

  if (error) {
    return (
      <div className="setup-authenticator_relogin">
        <ErrorMessage danger>{t(error)}</ErrorMessage>
        <SecondaryButton
          color="orange"
          text={t('common.retry')}
          onClick={handleError}
          classNames="setup-authenticator_relogin__btn"
          fullWidth={false}
        />
      </div>
    )
  }

  if (isLogged && user.isLogged) {
    if (selectedPartner || hasSinglePartner(user)) {
      return (
        <FormPage title={t('Login.form.title')}>
          <LoginSuccess state={loginState} showSplash={showSplash} setShowSplash={setShowSplash} />
        </FormPage>
      )
    } else {
      return (
        <FormPage
          title={t('Login.form.partnerSelectTitle')}
          subtitle={t('Login.form.partnerSelectSubtitle')}
        >
          <PartnerSelect
            setSelectedPartner={setSelectedPartner}
            dispatch={dispatch}
            cognitoGroups={user.cognitoGroups}
          />
        </FormPage>
      )
    }
  }

  return null
}

